// Resolves this device's public IP, used as a device proxy for the
// one-device-per-day login lock (real device IDs aren't available on the
// device model this app runs on).
export const getPublicIp = async () => {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 5000)

  try {
    const response = await fetch("https://api.ipify.org/?format=json", {
      signal: controller.signal,
    })
    if (!response.ok) {
      throw new Error(`ipify responded with status ${response.status}`)
    }
    const data = await response.json()
    if (!data?.ip) {
      throw new Error("ipify response did not include an ip")
    }
    return data.ip
  } finally {
    clearTimeout(timeoutId)
  }
}
